@if(evaluationType === EvaluationType.General){
  <span>{{ l('::General') }}</span>
} @else if (evaluationType === EvaluationType.AreaSpecific){
  <span>{{ l('::AreaSpecific') }}</span>
} @else if (evaluationType === EvaluationType.Autoevaluation){
  <span>{{ l('::Autoevaluation') }}</span>
} @else{
  <span>{{ l('::Calibration') }}</span>
}
